import { createAction, props } from '@ngrx/store';
import { StepItems } from 'src/app/shared/components/stepper/stepper.component';

const CREATE_POSITION_KEY = '[Create position]';

export const SetVacancyId = createAction(
  `${CREATE_POSITION_KEY} set vacancy id`,
  props<{ vacancyId: string }>()
);

export const CheckServerSteps = createAction(
  `${CREATE_POSITION_KEY} check server steps`
);

export const InitSteps = createAction(
  `${CREATE_POSITION_KEY} init steps`
);

export const SetSteps = createAction(
  `${CREATE_POSITION_KEY} set steps`,
  props<{ steps: StepItems [], currentStep: number }>()
);

export const SetCurrentStep = createAction(
  `${CREATE_POSITION_KEY} set current step`,
  props<{ currentStep: number }>()
);

export const GetJobTitles = createAction(
  `${CREATE_POSITION_KEY} get job titles`
);

export const GetJobTitlesSuccess = createAction(
  `${CREATE_POSITION_KEY} get job titles success`,
  props<{ jobTitles: any[] }>()
);

export const GetJobTitlesFailure = createAction(
  `${CREATE_POSITION_KEY} get job titles failure`,
  props<{ err: any }>()
);

export const SetJobPosition = createAction(
  `${CREATE_POSITION_KEY} set job position`,
  props<{
    jobPosition: string,
    jobPositions: string[],
    jobDescription: string,
    selectedJobDescriptionFile: File | null,
    wasChanged: boolean
  }>()
);

export const SetJobPositionFailure = createAction(
  `${CREATE_POSITION_KEY} set job position failure`,
  props<{ error: any }>()
);

export const SetAdditionalJobPositions = createAction(
  `${CREATE_POSITION_KEY} set additional job positions`,
  props<{ jobPositions: string[] }>()
);

export const StepValid = createAction(
  `${CREATE_POSITION_KEY} step valid`,
  props<{ key: string, data: any, wasChanged: boolean }>()
);

export const StepValidSaved = createAction(
  `${CREATE_POSITION_KEY} step valid saved`,
  props<{ key: string, data: any }>()
);

export const GetVacancy = createAction(
  `${CREATE_POSITION_KEY} get vacancy`,
  props<{ vacancyId: any, useServerHardSkills?: boolean }>()
);

export const GetVacancySuccess = createAction(
  `${CREATE_POSITION_KEY} get vacancy success`,
  props<{ vacancy: any }>()
);

export const GetVacancyFailure = createAction(
  `${CREATE_POSITION_KEY} get vacancy failure`,
);

export const SetHardSkills = createAction(
  `${CREATE_POSITION_KEY} set hard skills`,
  props<{ skillsList: any[], noServer?: boolean }>()
);

export const GetHardSkills = createAction(
  `${CREATE_POSITION_KEY} get hard skills`
);

export const GetHardSkillsSuccess = createAction(
  `${CREATE_POSITION_KEY} get hard skills success`,
  props<{ skillsList: any[] }>()
);

export const GetHardSkillsFailure = createAction(
  `${CREATE_POSITION_KEY} get hard skills failure`,
  props<{ err: any }>()
);

export const GetSoftSkills = createAction(
  `${CREATE_POSITION_KEY} get soft skills`
);

export const GetSoftSkillsSuccess = createAction(
  `${CREATE_POSITION_KEY} get soft skills success`,
  props<{ skillsList: any[] }>()
);

export const GetSoftSkillsFailure = createAction(
  `${CREATE_POSITION_KEY} get soft skills failure`,
  props<{ err: any }>()
);

export const SetSoftSkills = createAction(
  `${CREATE_POSITION_KEY} set soft skills`,
  props<{ skillsList: any[] }>()
);

export const GetSkillsList = createAction(
  `${CREATE_POSITION_KEY} get skills list`
);

export const GetSkillsListSuccess = createAction(
  `${CREATE_POSITION_KEY} get skills list success`,
  props<{ skillsList: any[] }>()
);

export const GetSkillsListFailure = createAction(
  `${CREATE_POSITION_KEY} get skills list failure`,
  props<{ err: any }>()
);

export const SaveVacancy = createAction(
  `${CREATE_POSITION_KEY} save vacancy`,
  props<{ publish: boolean, redirect?: boolean }>()
);

export const DropVacancy = createAction(
  `${CREATE_POSITION_KEY} drop vacancy`
);

export const SetSeniority = createAction(
  `${CREATE_POSITION_KEY} set seniority`,
  props<{ level: string }>()
);

export const SetCountry = createAction(
  `${CREATE_POSITION_KEY} set country`,
  props<{ country: string | null }>()
);

export const SetCurrency = createAction(
  `${CREATE_POSITION_KEY} set currency`,
  props<{ currency: string }>()
);

export const SetRequireValidation = createAction(
  `${CREATE_POSITION_KEY} Set Require Validation`,
  props<{ value: boolean }>()
);

export const PublishCompleted = createAction(
  '[Create Position] Publish Completed',
  props<{ vacancyId: string, status: string, approvedEmailAutomation: boolean }>()
)

export const SaveDraftCompleted = createAction(
  '[Create Position] Save Draft Completed'
)

export const SetVacancyStatusFailure = createAction(
  `${CREATE_POSITION_KEY} set vacancy status failure`,
  props<{ error: any }>()
);

